const clients = [
  {
    id: 11,
    system: "VENTURUS",
    module: "ZNAP_CASH_FLOW",
    modulePath: "hml-new-netsuite.dfc",
    moduleName: "dfc",
    language: "pt",
    port: 8089,
    theme: "venturus.js",
    env: "hml-new-netsuite",
  },
];

const getClientConfigs = (clientId) =>
  clients.find((client) => client.id === clientId);
const configs = getClientConfigs(11);

export default {
  ...configs,
};
